module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"placeholder":"選択してください","buttons":{"cancel":"キャンセル","confirm":"確定"}},"en":{"placeholder":"Select","buttons":{"cancel":"Cancel","confirm":"Confirm"}}}')
  delete Component.options._Ctor
}
